module.exports = __webpack_public_path__ + "img/gb9123_27_d.prt.93535b01.jpg";